module.exports = __webpack_public_path__ + "static/media/removed-trash.d3710ce2.svg";